"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find-index");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _milkRun = require("@/mixins/milk-run/milk-run");

var _elementUi = require("element-ui");

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

var _moment = _interopRequireDefault(require("moment"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRGanttChartComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRGanttChartComponent, _Mixins);

  var _super = _createSuper(MRGanttChartComponent);

  function MRGanttChartComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRGanttChartComponent);
    _this = _super.apply(this, arguments);
    _this.truckWidth = 0;
    _this.locations = {};
    _this.isFilterTruck = false;
    _this.isShowEnabledTruck = false;
    _this.isTicking = false;
    _this.lastScrollLeft = 0;
    _this.timeList = [];
    _this.numOfDaysAdded = 0;
    _this.autoAddedDays = 0;
    _this.maxAutoAddedDays = 1;
    _this.timeStepper = 240;
    _this.autoScrollInterval = null;
    _this.scrollTimeRefresh = 1; // seconds

    _this.currentTimeInterval = null;
    _this.currentTimeRefresh = 30; // seconds

    _this.currentTimeLeft = null;
    _this.leftWidth = 225;
    _this.smallLeftWidth = 100;
    _this.truckPagination = 1;
    _this.truckPageSize = 50;
    return _this;
  }

  (0, _createClass2.default)(MRGanttChartComponent, [{
    key: "onInitAutoAddedDaysChanges",
    value: function onInitAutoAddedDaysChanges(newVal) {
      this.timeList = this.getTimeList(newVal);
    }
  }, {
    key: "onPlanDateRangeChanges",
    value: function onPlanDateRangeChanges(newVal) {
      if (this.planViewType === 'daily') {
        this.timeList = this.getTimeList(0, newVal[0], newVal[1]);
      }
    }
  }, {
    key: "onTruckFiltersChanges",
    value: function onTruckFiltersChanges(newVal) {
      var index = newVal.findIndex(function (filter) {
        return filter.key === 'status';
      });

      if (newVal.length === 0 || index === -1) {
        this.isFilterTruck = false;
        this.isShowEnabledTruck = false;
        return;
      }

      this.isFilterTruck = true;
      this.isShowEnabledTruck = newVal[index]['value'] === 'Enabled Trucks';
    }
  }, {
    key: "onTimeStepperChanges",
    value: function onTimeStepperChanges(newVal) {
      var _this2 = this;

      var ganttChart = this.helper.get(this.$refs, 'ganttChart', null);

      if (ganttChart) {
        ganttChart.scrollTo(0, 0);
      }

      this.timeStepper = newVal;
      this.timeList = this.getTimeList(this.numOfDaysAdded);
      this.$nextTick(function () {
        var el = _this2.helper.get(_this2.$refs, 'ganttChart', null);

        if (!el) {
          return false;
        }

        el.scrollTo(_this2.xCoordinate, el.scrollTop);

        _this2.getCurrentTimeLocation();
      });
    }
  }, {
    key: "onBooleanEnableTrucksChanges",
    value: function onBooleanEnableTrucksChanges(newVal) {
      return newVal ? this.enableAllTrucks() : this.disableAllTrucks();
    }
  }, {
    key: "onTruckLoadingChanges",
    value: function onTruckLoadingChanges() {
      var _this3 = this;

      this.$nextTick(function () {
        var el = _this3.helper.get(_this3.$refs, 'ganttChart', null);

        if (!el) {
          return false;
        }

        el.scrollTo(_this3.xCoordinate, el.scrollTop);

        _this3.getCurrentTimeLocation();
      });
    }
  }, {
    key: "filteredTrucks",
    get: function get() {
      var _this4 = this;

      var end = this.truckPagination * this.truckPageSize < this.$trucks.length ? this.truckPagination * this.truckPageSize : this.$trucks.length;

      if (!this.isFilterTruck) {
        return this.$trucks.slice(0, end);
      }

      var disabledTrucks = [];

      if (window.localStorage.getItem(this.disableTruckKey)) {
        disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
      }

      var trucks = this.$trucks.filter(function (truck) {
        var bool2 = !_this4.helper.includes(disabledTrucks, truck['id'].toString());
        return _this4.isShowEnabledTruck ? bool2 : !bool2;
      });
      end = this.truckPagination * this.truckPageSize < trucks.length ? this.truckPagination * this.truckPageSize : trucks.length;
      return trucks.slice(0, end);
    }
  }, {
    key: "gcContainerStyle",
    get: function get() {
      return {
        height: this.ganttChartHeight + 'px',
        // top: !this.isVerticallyAutoScrolling ? 0 : this.$isFullscreen ? '44px' : '47px',
        top: 0
      };
    }
  }, {
    key: "gcHeaderStyle",
    get: function get() {
      /*if (!this.isVerticallyAutoScrolling) {
      return {
      width: this.truckWidth + 'px',
      top: 0,
      position: 'sticky',
      };
      } else {
      return {
      width: this.truckWidth + 'px',
      top: this.$isFullscreen ? 0 : '60px',
      position: 'fixed',
      };
      }*/
      return {
        width: this.truckWidth + 'px'
      };
    }
  }, {
    key: "isTodayInRange",
    get: function get() {
      return (0, _moment.default)(new Date()).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]');
    }
  }, {
    key: "xCoordinate",
    get: function get() {
      var el = this.helper.get(this.$refs, 'ganttChart', null);

      if (!el) {
        return 0;
      }

      var start = (0, _moment.default)(this.$planDateRange[0]).format('YYYY-MM-DD 00:00');
      var end = (0, _moment.default)(new Date());

      if (!this.isTodayInRange) {
        end = (0, _moment.default)(this.$planDateRange[1]);
      }

      var duration = _moment.default.duration(end.diff(start, 'minutes'), 'minutes').asMinutes();

      var xAxis = duration * this.ganttChartCellWidth / this.timeStepper;
      return xAxis - el.clientWidth / 3;
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
      }

      if (this.currentTimeInterval) {
        clearInterval(this.currentTimeInterval);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.timeStepper = this.defaultTimeStepper;
      this.timeList = this.getTimeList();

      if (window.localStorage.getItem(this.disableTruckKey)) {
        this.disableTruckList = window.localStorage.getItem(this.disableTruckKey).split(',');
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this5 = this;

      this.autoAddedDays = this.initAutoAddedDays;
      this.currentTimeInterval = setInterval(function () {
        _this5.handleHorizontallyScrolling();

        _this5.getCurrentTimeLocation();
      }, this.currentTimeRefresh * 1000);

      if (this.isVerticallyAutoScrolling) {
        this.autoScrollInterval = setInterval(function () {
          _this5.handleVerticallyAutoScrolling();
        }, this.scrollTimeRefresh * 1000);
      }
    }
    /*getStatusColor(route): string | boolean {
    const status = route['status'];
    const waypoints = this.getWaypointsFromIds(route['waypointId']);
     if (status === 'assigned' || status === 'completed') {
      return this.helper.every(waypoints, (wp) => wp['completedTime'] !== null && wp['completedTime'] !== '0000-00-00 00:00:00') // all waypoints are completed
        ? 'completed'
        : 'inTransit';
    }
     if (status === 'unassigned') {
      return 'unassigned';
    }
    }*/

  }, {
    key: "handleHorizontallyScrolling",
    value: function handleHorizontallyScrolling() {
      var el = this.helper.get(this.$refs, 'ganttChart', null);

      if (!el) {
        return false;
      }

      el.scrollTo(el.scrollLeft + 1, el.scrollTop);
    }
  }, {
    key: "handleVerticallyAutoScrolling",
    value: function handleVerticallyAutoScrolling() {
      if (this.isPause) {
        return false;
      }

      var el = this.helper.get(this.$refs, 'ganttChart', null);

      if (!el) {
        return false;
      }

      if (el.scrollHeight - el.scrollTop === el.clientHeight && el.scrollHeight !== el.clientHeight) {
        el.scrollTo(el.scrollLeft, 0);
      } else {
        el.scrollBy(0, 32);
      }
    }
  }, {
    key: "hasData",
    value: function hasData(truckId) {
      return this.getRoutes(truckId).length >= 1;
    }
  }, {
    key: "openWindow",
    value: function openWindow(link) {
      window.open(link);
    }
  }, {
    key: "openMap",
    value: function openMap(truckId, truckName) {
      if (this.getRoutes(truckId).length >= 1) {
        var truckData = this.getRoutes(truckId);

        if (truckData[0] && truckData[0]['lat'] && truckData[0]['lng']) {
          this.locations = {
            latitude: Number(truckData[0]['lat']),
            longitude: Number(truckData[0]['lng'])
          };
        }

        if (truckData[0] && truckData[0]['latitude'] && truckData[0]['longitude']) {
          this.locations = {
            latitude: Number(truckData[0]['latitude']),
            longitude: Number(truckData[0]['longitude'])
          };
        }

        this.selectedTruckName = truckName;
        this.selectedTruckData = truckData;
        window.localStorage.setItem('tName', this.helper.toString(this.selectedTruckName));
        window.localStorage.removeItem('tContainerNum');
        window.localStorage.removeItem('tGpsId');
        window.localStorage.setItem('tLocation', this.helper.toString(this.locations));
        window.localStorage.setItem('tData', this.helper.toString(this.selectedTruckData));
        window.localStorage.setItem('tInitEvent', 'polylines'); // const mapWorld = this.helper.get(this.$refs, 'mapWorld', null);
        // if (mapWorld) { mapWorld.refreshMap(this.selectedTruckData); }

        var routeData = this.$router.resolve({
          name: 'map'
        });
        window.open(routeData.href, this.selectedTruckName, 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=600, height=600'); // this.openMapModal = true;
      }
    }
  }, {
    key: "clearSelectedTrucks",
    value: function clearSelectedTrucks() {
      // this.openMapModal = false;
      this.selectedTruckName = '';
      this.selectedTruckData = [];
    }
  }, {
    key: "setTruck",
    value: function setTruck(truckId) {
      /*if (this.$anyChanges) {
      const message: ElNotificationOptions = {
      title: this.$i18n.t('planning.messages.saveBeforeSwitchTruck'),
      duration: 5000
      } as ElNotificationOptions;
      Notification.warning(message);
      }*/

      /*if (
      this.isClickable &&
      !this.checkDisable(truckId) &&
      !this.isTruckIdExistInGlobal(truckId) &&
      !this.$anyChanges
      ) {*/
      if (this.isClickable && !this.checkDisable(truckId)) {
        // Socket for global trucks

        /*this.socketAPI.updateLMDGlobalSelectedTrucks({
        user: this.$userInformation.user.name,
            truckId: truckId ? [truckId] : [],
        });*/
        this.$setSelectedTruck(truckId);
      }
    }
  }, {
    key: "hasRouteDetails",
    value: function hasRouteDetails(truckId) {
      var routeDistance = this.getRouteDetails(truckId)['estimatedDistance'];
      var routeTime = this.getRouteDetails(truckId)['estimatedTime'];
      return routeDistance || routeTime;
    }
  }, {
    key: "checkDisable",
    value: function checkDisable(truckId) {
      return !(this.hasData(truckId) || !this.disableTruckList || this.disableTruckList.indexOf(truckId.toString()) === -1);
    }
  }, {
    key: "disableTruck",
    value: function disableTruck(truckId) {
      if (!this.hasData(truckId)) {
        if (truckId) {
          this.disableTruckList.push(truckId.toString());
        }

        this.$setSelectedTruck(null);
        localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
      }
    }
  }, {
    key: "enableTruck",
    value: function enableTruck(truckId) {
      if (truckId) {
        this.disableTruckList = this.disableTruckList.filter(function (i) {
          return i !== truckId.toString();
        });
      }

      localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
    }
  }, {
    key: "enableAllTrucks",
    value: function enableAllTrucks() {
      var _this6 = this;

      this.$trucks.forEach(function (truck) {
        return _this6.enableTruck(truck['id']);
      });
    }
  }, {
    key: "disableAllTrucks",
    value: function disableAllTrucks() {
      var _this7 = this;

      this.$trucks.forEach(function (truck) {
        return _this7.disableTruck(truck['id']);
      });
    }
  }, {
    key: "getTimeList",
    value: function getTimeList() {
      var daysOfIncrement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$planDateRange[0];
      var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$planDateRange[1];
      var stepper = this.timeStepper;
      var start = this.helper.isUndefined(startDate) ? (0, _moment.default)(this.$planDateRange[0]) : (0, _moment.default)(startDate);
      var eDate = this.helper.isUndefined(startDate) ? (0, _moment.default)(this.$planDateRange[1]) : (0, _moment.default)(endDate);
      var end = daysOfIncrement === 0 ? (0, _moment.default)(eDate) : (0, _moment.default)(startDate).add(daysOfIncrement, 'days');

      var duration = _moment.default.duration(end.diff(start, 'days'), 'days').asDays();

      var endTime = (0, _moment.default)('00:00', 'HH:mm').subtract(stepper, 'm').format('HH:mm');
      var arr = [];
      var ctr = 0;

      for (var i = 0; i <= duration; i++) {
        var time = (0, _moment.default)('00:00', 'HH:mm');
        ctr = ctr + (i === 0 ? 0 : 1);
        var obj = {
          date: i === 0 ? start.format('YYYY-MM-DD') : start.add(1, 'days').format('YYYY-MM-DD'),
          timeList: [{
            time: time.format('HH:mm'),
            counter: ctr
          }]
        };

        while (time.format('HH:mm') !== endTime) {
          ctr++;
          time = time.add(stepper, 'm');
          obj['timeList'].push({
            time: time.format('HH:mm'),
            counter: ctr
          });
        }

        arr.push(obj);
      }

      var numOfDays = arr.length;

      if (arr[0] && arr[0]['timeList']) {
        this.truckWidth = numOfDays * arr[0]['timeList'].length * this.ganttChartCellWidth + (this.$isMobile ? this.smallLeftWidth : this.leftWidth);
      }

      return arr;
    }
  }, {
    key: "isShowCheckmark",
    value: function isShowCheckmark(truck) {
      return !this.isVerticallyAutoScrolling && this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truck['id'];
      }), '0.routes', []).length === 0;
    }
  }, {
    key: "getRouteStyles",
    value: function getRouteStyles(route, dimensionType, routeType) {
      if (this.routeViewOptions.length === 1) {
        return {
          height: dimensionType === 'handlingTime' || dimensionType === 'suggestedHandlingTime' || dimensionType === 'actualHandlingTime' ? '20px' : '4px',
          top: '0',
          bottom: '0',
          left: this.getLeftDimension(dimensionType, route) + 'px',
          width: this.getWidthDimension(dimensionType, route) + 'px',
          // opacity: route['isHighlighted'] ? 0.8 : 1,
          opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
        };
      } else if (this.routeViewOptions.length === 2) {
        if (this.routeViewOptions.includes('plannedRoutes') && this.routeViewOptions.includes('suggestedRoutes')) {
          switch (dimensionType) {
            case 'travellingTime':
              return {
                top: '5px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'handlingTime':
              return {
                height: '14px',
                top: '0',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'suggestedTravellingTime':
              return {
                bottom: '6px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'suggestedHandlingTime':
              return {
                height: '14px',
                bottom: '1px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };
          }
        } else if (this.routeViewOptions.includes('suggestedRoutes') && this.routeViewOptions.includes('actualRoutes')) {
          switch (dimensionType) {
            case 'suggestedTravellingTime':
              return {
                bottom: '5px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'suggestedHandlingTime':
              return {
                height: '14px',
                bottom: '0',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'actualTravellingTime':
              return {
                bottom: '6px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'actualHandlingTime':
              return {
                height: '14px',
                bottom: '1px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };
          }
        } else if (this.routeViewOptions.includes('plannedRoutes') && this.routeViewOptions.includes('actualRoutes')) {
          switch (dimensionType) {
            case 'travellingTime':
              return {
                top: '5px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'handlingTime':
              return {
                height: '14px',
                top: '0',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'actualTravellingTime':
              return {
                bottom: '6px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };

            case 'actualHandlingTime':
              return {
                height: '14px',
                bottom: '1px',
                left: this.getLeftDimension(dimensionType, route) + 'px',
                width: this.getWidthDimension(dimensionType, route) + 'px',
                // opacity: route['isHighlighted'] ? 0.8 : 1,
                opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
              };
          }
        }
      } else {
        var opacity = 1;

        switch (routeType) {
          case 'plannedRoutes':
            // opacity = route['isHighlighted'] ? 0.5 : 0.7;
            opacity = route['planId'] === this.currentPlanId ? 0.5 : 1;
            break;

          case 'suggestedRoutes':
            // opacity = route['isHighlighted'] ? 0.2 : 0.4;
            opacity = route['planId'] === this.currentPlanId ? 0.5 : 1;
            break;

          case 'actualRoutes':
            // opacity = route['isHighlighted'] ? 0.8 : 1;
            opacity = route['planId'] === this.currentPlanId ? 0.5 : 1;
            break;
        }

        return {
          height: dimensionType === 'handlingTime' || dimensionType === 'suggestedHandlingTime' || dimensionType === 'actualHandlingTime' ? '20px' : '4px',
          top: '0',
          bottom: '0',
          left: this.getLeftDimension(dimensionType, route) + 'px',
          width: this.getWidthDimension(dimensionType, route) + 'px',
          opacity: opacity,
          'z-index': '2'
        };
      }
    }
  }, {
    key: "getActualRouteClass",
    value: function getActualRouteClass(route) {
      if (route.waypointType === 'T') {
        return 'action';
      }

      if (!route.actualData) {
        return '';
      }

      if (route.actualData.estimateOnTime && route.actualData.endOnTime) {
        return 'is-punctual';
      } else if (route.actualData.estimateOnTime && !route.actualData.endOnTime || !route.actualData.estimateOnTime && route.actualData.endOnTime) {
        return 'is-quite-late';
      } else {
        return 'is-late';
      }
    }
  }, {
    key: "getIndexStyles",
    value: function getIndexStyles() {
      if (this.routeViewOptions.length === 2) {
        return {
          'font-size': '10px',
          margin: '0 4px'
        };
      }
    }
  }, {
    key: "getContainerStyles",
    value: function getContainerStyles(route, routeType) {
      if (this.routeViewOptions.length === 1 || this.routeViewOptions.length === 3) {
        return {
          top: '6px',
          left: this.getContainerDimension(true, route, routeType) + 'px',
          width: this.getContainerDimension(false, route, routeType) + 'px',
          height: '20px'
        };
      } else {
        if (this.routeViewOptions.includes('plannedRoutes') && this.routeViewOptions.includes('suggestedRoutes')) {
          switch (routeType) {
            case 'plannedRoutes':
              return {
                top: '1px',
                left: this.getContainerDimension(true, route, routeType) + 'px',
                width: this.getContainerDimension(false, route, routeType) + 'px',
                height: '14px'
              };

            case 'suggestedRoutes':
              return {
                bottom: '1px',
                left: this.getContainerDimension(true, route, routeType) + 'px',
                width: this.getContainerDimension(false, route, routeType) + 'px',
                height: '14px'
              };
          }
        } else if (this.routeViewOptions.includes('suggestedRoutes') && this.routeViewOptions.includes('actualRoutes')) {
          switch (routeType) {
            case 'suggestedRoutes':
              return {
                bottom: '1px',
                left: this.getContainerDimension(true, route, routeType) + 'px',
                width: this.getContainerDimension(false, route, routeType) + 'px',
                height: '14px'
              };

            case 'actualRoutes':
              return {
                top: '1px',
                left: this.getContainerDimension(true, route, routeType) + 'px',
                width: this.getContainerDimension(false, route, routeType) + 'px',
                height: '14px'
              };
          }
        } else if (this.routeViewOptions.includes('plannedRoutes') && this.routeViewOptions.includes('actualRoutes')) {
          switch (routeType) {
            case 'plannedRoutes':
              return {
                top: '1px',
                left: this.getContainerDimension(true, route, routeType) + 'px',
                width: this.getContainerDimension(false, route, routeType) + 'px',
                height: '14px'
              };

            case 'actualRoutes':
              return {
                bottom: '1px',
                left: this.getContainerDimension(true, route, routeType) + 'px',
                width: this.getContainerDimension(false, route, routeType) + 'px',
                height: '14px'
              };
          }
        }
      }
    }
  }, {
    key: "getContainerDimension",
    value: function getContainerDimension(isLeft) {
      var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var routeType = arguments.length > 2 ? arguments[2] : undefined;
      var newRoute = this.helper.cloneDeep(route);
      var start = this.helper.convertTimezone(newRoute.startTime, this.$timezone);
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.handlingTime = Number(newRoute.handlingTime) / 60;
      newRoute.suggestedData.time = Number(newRoute.suggestedData.time) / 60;
      newRoute.suggestedData.handlingTime = Number(newRoute.suggestedData.handlingTime) / 60;
      newRoute.actualData.time = Number(newRoute.actualData.time) / 60;
      newRoute.actualData.handlingTime = Number(newRoute.actualData.handlingTime) / 60;

      if (routeType === 'suggestedRoutes') {
        start = this.helper.convertTimezone(newRoute.suggestedData.startTime, this.$timezone);
      }

      if (routeType === 'actualRoutes') {
        if (newRoute.waypointType !== 'T') {
          start = this.helper.convertTimezone(newRoute.actualData.startTime, this.$timezone);
        }
      }

      if (this.helper.isUndefined(start)) {
        return 0;
      }

      var date = (0, _moment.default)(start).format('YYYY-MM-DD');
      var startTime = (0, _moment.default)(start).format('YYYY-MM-DD 00:00');
      var endTime = (0, _moment.default)(start);

      var duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();

      if (date !== this.$planDateRange[0]) {
        var diff = (0, _moment.default)(date).diff((0, _moment.default)(this.$planDateRange[0]), 'days');
        startTime = (0, _moment.default)(start).subtract(diff, 'days').format('YYYY-MM-DD 00:00');
        duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();
      }

      if (routeType === 'plannedRoutes') {
        return multiplier * (isLeft ? duration : newRoute.time + newRoute.waitingTime + newRoute.handlingTime);
      }

      if (routeType === 'suggestedRoutes') {
        return multiplier * (isLeft ? duration : newRoute.suggestedData.time + newRoute.suggestedData.waitingTime + newRoute.suggestedData.handlingTime);
      }

      if (routeType === 'actualRoutes') {
        return newRoute.waypointType === 'T' ? multiplier * (isLeft ? duration : newRoute.time + newRoute.waitingTime + newRoute.handlingTime) : multiplier * (isLeft ? duration : newRoute.actualData.time + newRoute.actualData.waitingTime + newRoute.actualData.handlingTime);
      }
    }
    /**
     * 30 minutes   = 54      <-- ganttChartCellWidth
     * 1 minute     = 1.8px   <-- 54/this.stepper
     * */

  }, {
    key: "getLeftDimension",
    value: function getLeftDimension(timeType, route) {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var newRoute = this.helper.cloneDeep(route);
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.handlingTime = Number(newRoute.handlingTime) / 60;
      newRoute.suggestedData.handlingTime = Number(newRoute.suggestedData.handlingTime) / 60;
      newRoute.suggestedData.time = Number(newRoute.suggestedData.time) / 60;
      newRoute.actualData.time = Number(newRoute.actualData.time) / 60;
      newRoute.actualData.handlingTime = Number(newRoute.actualData.handlingTime) / 60;

      if (timeType === 'travellingTime') {
        return 0;
      }

      if (timeType === 'handlingTime') {
        return multiplier * (newRoute.time + newRoute.waitingTime);
      }

      if (timeType === 'suggestedTravellingTime') {
        return 0;
      }

      if (timeType === 'suggestedHandlingTime') {
        return multiplier * (newRoute.suggestedData.time + newRoute.suggestedData.waitingTime);
      }

      if (timeType === 'actualTravellingTime') {
        return 0;
      }

      if (timeType === 'actualHandlingTime') {
        return newRoute.waypointType === 'T' ? multiplier * (newRoute.time + newRoute.waitingTime) : multiplier * (newRoute.actualData.time + newRoute.actualData.waitingTime);
      }
    }
  }, {
    key: "getWidthDimension",
    value: function getWidthDimension(timeType, route) {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var newRoute = this.helper.cloneDeep(route);
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.handlingTime = Number(newRoute.handlingTime) / 60;
      newRoute.suggestedData.time = Number(newRoute.suggestedData.time) / 60;
      newRoute.suggestedData.handlingTime = Number(newRoute.suggestedData.handlingTime) / 60;
      newRoute.actualData.time = Number(newRoute.actualData.time) / 60;
      newRoute.actualData.handlingTime = Number(newRoute.actualData.handlingTime) / 60;

      if (timeType === 'travellingTime') {
        return multiplier * newRoute.time;
      }

      if (timeType === 'handlingTime') {
        return multiplier * newRoute.handlingTime;
      }

      if (timeType === 'suggestedTravellingTime') {
        return multiplier * newRoute.suggestedData.time;
      }

      if (timeType === 'suggestedHandlingTime') {
        return multiplier * newRoute.suggestedData.handlingTime;
      }

      if (timeType === 'actualTravellingTime') {
        return newRoute.waypointType === 'T' ? multiplier * newRoute.time : multiplier * newRoute.actualData.time;
      }

      if (timeType === 'actualHandlingTime') {
        return newRoute.waypointType === 'T' ? multiplier * newRoute.handlingTime : multiplier * newRoute.actualData.handlingTime;
      }
    }
  }, {
    key: "getRouteSeparatorClass",
    value: function getRouteSeparatorClass(routes, route) {
      if (this.isRouteFirstPlan(routes, route)) {
        return {
          'route-separator': true,
          begin: true
        };
      } else if (this.isRouteFirstPlan(routes, route, false)) {
        return {
          'route-separator': true,
          end: true
        };
      } else {
        return '';
      }
    }
  }, {
    key: "getRouteSeparatorStyle",
    value: function getRouteSeparatorStyle() {
      if (this.routeViewOptions.length === 1 || this.routeViewOptions.length === 3) {
        return {
          height: '31px',
          top: '-6px'
        };
      } else {
        return {
          height: '16px',
          top: '-1px'
        };
      }
    }
  }, {
    key: "isRouteFirstPlan",
    value: function isRouteFirstPlan(routes, route) {
      var isFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var fRoutes = routes.filter(function (r) {
        return r['planId'] === route.planId;
      });
      var length = fRoutes.length;
      var index = this.helper.findIndex(fRoutes, function (r) {
        return r['code'] === route.code;
      });
      return isFirst ? index === 0 : index === length - 1;
    }
  }, {
    key: "getCycleNumberClass",
    value: function getCycleNumberClass(routes, route) {
      if (this.isRouteFirstPlan(routes, route)) {
        return {
          'cycle-number-container': true
        };
      } else {
        return '';
      }
    }
  }, {
    key: "getCycleNumberStyle",
    value: function getCycleNumberStyle() {
      if (this.routeViewOptions.length === 1 || this.routeViewOptions.length === 3) {
        return {
          width: '20px',
          height: '20px',
          top: '0',
          left: '-22px'
        };
      } else {
        return {
          width: '14px',
          height: '14px',
          top: '0',
          left: '-16px'
        };
      }
    }
  }, {
    key: "getCurrentTimeLocation",
    value: function getCurrentTimeLocation() {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var start = (0, _moment.default)(new Date());
      var date = (0, _moment.default)(start).format('YYYY-MM-DD');
      var startTime = (0, _moment.default)(start).format('YYYY-MM-DD 00:00');
      var endTime = (0, _moment.default)(start);

      var duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();

      if (date !== this.$planDateRange[0]) {
        var diff = (0, _moment.default)(date).diff((0, _moment.default)(this.$planDateRange[0]), 'days');
        startTime = (0, _moment.default)(start).subtract(diff, 'days').format('YYYY-MM-DD 00:00');
        duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();
      }

      this.currentTimeLeft = multiplier * duration;
    }
  }, {
    key: "getGCRowClass",
    value: function getGCRowClass(truck, truckIndex) {
      var _ref;

      var className = truck.id === this.$selectedTruck ? 'is-active' : this.isTruckIdExistInGlobal(truck.id) ? 'is-used' : 'is-disabled';
      return _ref = {}, (0, _defineProperty2.default)(_ref, className, true), (0, _defineProperty2.default)(_ref, 'bdr-btm-none', truckIndex === this.filteredTrucks.length - 1), (0, _defineProperty2.default)(_ref, 'cursor-pointer', this.isClickable && !this.checkDisable(truck.id) && !this.isTruckIdExistInGlobal(truck.id)), _ref;
    }
  }, {
    key: "getGCRowStyle",
    value: function getGCRowStyle(truck, truckIndex) {
      return {
        width: this.truckWidth + 'px',
        'margin-top': truckIndex === 0 ? '1px' : '0'
      };
    }
  }, {
    key: "isDateInRange",
    value: function isDateInRange(route, routeType) {
      switch (routeType) {
        case 'plannedRoutes':
          return (0, _moment.default)(route.startTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(route.endTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(this.$planDateRange[0]).isBetween(route.startTime, route.endTime, 'days', '[]') || (0, _moment.default)(this.$planDateRange[1]).isBetween(route.startTime, route.endTime, 'days', '[]');

        case 'suggestedRoutes':
          return (0, _moment.default)(route.suggestedData.startTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(route.suggestedData.endTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(this.$planDateRange[0]).isBetween(route.suggestedData.startTime, route.suggestedData.endTime, 'days', '[]') || (0, _moment.default)(this.$planDateRange[1]).isBetween(route.suggestedData.startTime, route.suggestedData.endTime, 'days', '[]');

        case 'actualRoutes':
          return (0, _moment.default)(route.actualData.startTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(route.actualData.endTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(this.$planDateRange[0]).isBetween(route.actualData.startTime, route.actualData.endTime, 'days', '[]') || (0, _moment.default)(this.$planDateRange[1]).isBetween(route.actualData.startTime, route.actualData.endTime, 'days', '[]');
      }
    }
  }, {
    key: "appendMoreTruck",
    value: function appendMoreTruck() {
      this.truckPagination += 1;
    }
  }]);
  return MRGanttChartComponent;
}((0, _vuePropertyDecorator.Mixins)(_milkRun.MilkRunMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], MRGanttChartComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'daily'
})], MRGanttChartComponent.prototype, "planViewType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 30
})], MRGanttChartComponent.prototype, "defaultTimeStepper", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 54
})], MRGanttChartComponent.prototype, "ganttChartCellWidth", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 600
})], MRGanttChartComponent.prototype, "ganttChartHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttChartComponent.prototype, "isVerticallyAutoScrolling", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttChartComponent.prototype, "isDashboard", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttChartComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttChartComponent.prototype, "isClickable", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttChartComponent.prototype, "isEnableAllTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 0
})], MRGanttChartComponent.prototype, "initAutoAddedDays", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: ['plannedRoutes']
})], MRGanttChartComponent.prototype, "routeViewOptions", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: null
})], MRGanttChartComponent.prototype, "currentPlanId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttChartComponent.prototype, "isPlay", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttChartComponent.prototype, "isPause", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('initAutoAddedDays')], MRGanttChartComponent.prototype, "onInitAutoAddedDaysChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$planDateRange')], MRGanttChartComponent.prototype, "onPlanDateRangeChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$truckFilters', {
  deep: true
})], MRGanttChartComponent.prototype, "onTruckFiltersChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('defaultTimeStepper')], MRGanttChartComponent.prototype, "onTimeStepperChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isEnableAllTrucks')], MRGanttChartComponent.prototype, "onBooleanEnableTrucksChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$truckLoading')], MRGanttChartComponent.prototype, "onTruckLoadingChanges", null);
MRGanttChartComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRGanttChartComponent',
  components: {
    'map-world': _mapWorld.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip,
    'el-dialog': _elementUi.Dialog,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button
  }
})], MRGanttChartComponent);
var _default = MRGanttChartComponent;
exports.default = _default;